import { cn } from "@/lib/utils"

/**
 * The SATBuddy wordmark, in the variant that is actually legible against the
 * current theme.
 *
 * The shipped logo draws "Buddy" in near-black. On `.dark` and `.custom-dark`
 * — the default for most visitors — that half of the brand name rendered at
 * roughly 1:1 contrast against a near-black page, so the logo read as "SAT"
 * with a smudge after it. `satbuddy-logo-dark.png` is the same artwork with
 * only those wordmark pixels lifted to the foreground colour; the mascot and
 * the orange "SAT" are byte-identical to the original.
 *
 * Swapped with CSS rather than `useTheme()` so there is no flash of the wrong
 * lockup on first paint and nothing to get wrong during hydration. The three
 * light themes (`:root`, `.dsat-school`, `.ielts`) keep the original.
 */
export function BrandLogo({ className }: { className?: string }) {
    return (
        <span className={cn("relative block h-8 w-32", className)}>
            <img
                src="/satbuddy-logo.png"
                alt="SATBuddy"
                className="h-full w-full object-contain object-left dark:hidden"
            />
            <img
                src="/satbuddy-logo-dark.png"
                alt="SATBuddy"
                className="hidden h-full w-full object-contain object-left dark:block"
            />
        </span>
    )
}
